export default {
  data () {
    return {
      seeRecords: []
    }
  },
  methods: {
    printViewDisbursementByCollectionCenter (status) {
      this.loadCompanyProfile()
      var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      pageUrl += 'disbursement?all=all'
      if (c.type !== 'admin') {
        if (c.role.name === 'Manager') {
          pageUrl += `&branch_id=${c.agent_profile.branch_id}`
        } else {
          pageUrl += `&agent_id=${c.id}`
        }
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (this.form.disbursementStartDate) {
        pageUrl += `&disbursementStartDate=${this.form.disbursementStartDate}`
      }
      if (this.form.disbursementEndDate) {
        pageUrl += `&disbursementEndDate=${this.form.disbursementEndDate}`
      }
      if (this.form.startEmiEndDate) {
        pageUrl += `&startEmiEndDate=${this.form.startEmiEndDate}`
      }
      if (this.form.endEmiEndDate) {
        pageUrl += `&endEmiEndDate=${this.form.endEmiEndDate}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      if (status) {
        pageUrl += `&status=${status}`
      }
      this.$axios
        .get(`${pageUrl}&searchTerm=group`, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          this.seeRecords = data.data
        }).catch(function (error) { console.log(error) })
      $('#printviewdisbursementcollectioncenterwise').modal({backdrop: 'static', keyboard: false})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DisbursementByCollectionCenter.js